import { useContext } from 'use-context-selector';

import { EditorContext, EditorContextData } from '../contexts';

export function useEditor(): EditorContextData {
  const contextData = useContext(EditorContext);
  if (contextData == null) {
    throw new Error('EditorContext is not in the scope');
  }
  return contextData;
}
